import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Avatar,
  Text,
  Select,
  Input,
  Group,
  Button,
  Tabs,
  SimpleGrid,
  Checkbox,
  Radio,
  Textarea,
  Progress,
  Loader,
} from "@mantine/core";
import { IconDownload, IconEye, IconTrash } from "@tabler/icons-react";
import fileSvg from "../../assets/img/file.svg"
import { useMedplum } from "@medplum/react";

const useStyles = createStyles(() => ({
  box1: {
    display: "flex",
    flexDirection: "row",
  },
  boxmain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "12px",
    borderRadius: "4px",
    backgroundColor: "#F1F9FF",
  },
  fileText: {
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
    cursor: "pointer",
    //color: "#262930",
  },
  svgfile: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  mainBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "10px",
    borderRadius: "4px",
    backgroundColor: "#F1F9FF",
  },
}));

interface DownloadFileProps {
  filesData: any;
  handleDowload: (fileObject: any, download?: boolean) => Promise<void>;
  onDelete: () => void;
  loader: [number[], React.Dispatch<React.SetStateAction<number[]>>];
}

export const DownloadFile: React.FC<DownloadFileProps> = ({
  filesData,
  handleDowload,
  onDelete,
  loader
}) => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [dLoader, setDLoader] = loader;
  const handleDownClick = async (file: any, index: number) => {
    setDLoader([...dLoader, index]);
    await handleDowload(file, true);
    setDLoader(dLoader.filter(i=>i!=index));
  }
  return (
    <Box mt={16}>
      <Box>
        <Box className={classes.boxmain}>
          <Box className={classes.box1}>
            <Title mr={4}>Files to Download</Title>
            <Title>{`(${filesData.length})`}</Title>
          </Box>
          <Button size="md" variant="filled" color="red" onClick={onDelete}>
            <IconTrash style={{ marginRight: "8px" }} /> Delete export
          </Button>
        </Box>
      </Box>
      <Box></Box>
      <Box mt={24} p={8}>
        {" "}
        <Checkbox.Group>
          <SimpleGrid cols={4} spacing="md" mt="xs">
            {filesData.map((file: any, index: number) => (
              <Box className={classes.mainBox}>
                <Box className={classes.svgfile}>
                  <img src={fileSvg} />
                  <Title c="blue" onClick={() => handleDowload(file)} className={classes.fileText}>{file.type}</Title>
                  <Title c="#586171" className={classes.fileText}>({file.fileCount})</Title>
                </Box>
                <Box className={classes.fileText} color="#586171">
                  <IconEye onClick={() => handleDowload(file)} style={{ height: '14px', }} color="#1C7ED6" />
                  {dLoader.includes(index)
                    ? <Loader color="#1C7ED6" size="sm" style={{ height: '14px' }} />
                    : <IconDownload onClick={() => handleDownClick(file, index)}
                      style={{ height: '14px' }} color="#1C7ED6 " />}
                </Box>
              </Box>
            ))}
          </SimpleGrid>
        </Checkbox.Group>
      </Box>
    </Box>
  );
};
